import http from '@/utils/request';

// 获取活动列表  /promoActivity/restful/portalActivityList

export function getPortalActivityList() {
  return http.request({
    url: '/mro/promoActivity/restful/portalActivityList',
    method: 'get',
  });
}

// 获取活动商品 /promoActivity/restful/product/{activityId}
export function getActivityGoods(data) {
  return http.request({
    url: '/mro/promoActivity/restful/product',
    method: 'get',
    params: data,
  });
}

// 活动详情 /promoActivity/restful/{id}
export function getActivityDetail(id) {
  return http.request({
    url: '/mro/promoActivity/restful/' + id,
    method: 'get',
  });
}

// 购物车商品优惠计算
//post: /mro/portalOrder / calculateCartOrder

export function calculateCartOrder(data) {
  return http.request({
    url: '/mro/portalOrder/calculateCartOrder',
    method: 'post',
    data,
  });
}
// mro/portalOrder/calculateOrderBySku 批量下单购物车计算
export function calculateOrderBySku(data) {
  return http.request({
    url: '/mro/portalOrder/calculateOrderBySku',
    method: 'post',
    data,
  });
}
